var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subtract"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 40.6427C0.772075 44.8289 4.44087 48 8.85029 48H18.1808L11.1811 37.8719C10.9912 37.8744 10.8002 37.8757 10.6081 37.8757H0V40.6427Z",
    fill: "url(#paint0_linear_805_4941)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 28.2005H9.93103C13.6928 28.2005 16.5016 27.4005 18.3574 25.8005C20.2132 24.1504 21.1411 21.9004 21.1411 19.0503C21.1411 16.1503 20.2132 13.9003 18.3574 12.3002C16.5016 10.7002 13.6928 9.90018 9.93103 9.90018H0V28.2005Z",
    fill: "url(#paint1_linear_805_4941)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6081 0C15.3229 0 19.3856 0.775015 22.7962 2.32504C26.2069 3.82507 28.8401 6.00011 30.6959 8.85016C32.5517 11.7002 33.4796 15.1003 33.4796 19.0503C33.4796 22.9504 32.5517 26.3255 30.6959 29.1755C28.8401 31.9756 26.2069 34.1256 22.7962 35.6256C22.7619 35.6408 22.7275 35.6558 22.693 35.6707L31.3114 48H39.0001C43.9706 48 48 43.9705 48 38.9999V9.00008C48 4.02947 43.9706 0 39.0001 0H10.6081Z",
    fill: "url(#paint2_linear_805_4941)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_805_4941",
    x1: -34.7597,
    y1: -36,
    x2: 47.7353,
    y2: 48.2585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FBFF22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#37BD6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_805_4941",
    x1: -34.7597,
    y1: -36,
    x2: 47.7353,
    y2: 48.2585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FBFF22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#37BD6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_805_4941",
    x1: -34.7597,
    y1: -36,
    x2: 47.7353,
    y2: 48.2585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FBFF22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#37BD6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconGreen);
export default __webpack_public_path__ + "static/media/LogoIcon-green.266f5da4fc5726cf3ec0fa87065f6d0c.svg";
export { ForwardRef as ReactComponent };